import Immutable from 'seamless-immutable';

import actions from './actions';

const initState = Immutable.from({
	loading: false
});

export default function buttonsReducer(state = initState, { type, payload }) {
	switch (type) {
		case actions.BUTTONS: {
			return Immutable.set(state, 'loading', payload.LOADING);
		}
		default: {
			return state;
		}
	}
}
